import _slicedToArray from "/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
var fileDownload = require("js-file-download");
import { request } from "@/js/http/http_request";
import { filterVAutocomplete, getErrorData, handleErrorData, ERROR_DATA } from "@/js/forms.js";
import { stockReservationTypes } from "@/js/lists.ts";
import ErrorModal from "@/components/modal/ErrorModal.vue";
export default {
  name: "StockExportDrawer",
  components: {
    ErrorModal: ErrorModal
  },
  props: {
    loggedUserData: Object
  },
  data: function data() {
    return {
      drawer: false,
      drawerWidth: "40%",
      isExporting: false,
      isLoadingCountries: false,
      isLoadingWarehouses: false,
      countries: [],
      warehouses: [],
      form: {
        storageCountryId: null,
        reservationType: null,
        warehouseIds: [],
        includeDirectProducer: false
      },
      ERROR_DATA: ERROR_DATA
    };
  },
  computed: {
    reservationOptions: function reservationOptions() {
      return Object.values(stockReservationTypes);
    },
    canExport: function canExport() {
      var _this$form$warehouseI;
      var hasWarehouses = ((_this$form$warehouseI = this.form.warehouseIds) === null || _this$form$warehouseI === void 0 ? void 0 : _this$form$warehouseI.length) > 0;
      var hasDirectProducer = this.form.includeDirectProducer;
      return (hasWarehouses || hasDirectProducer) && !this.isExporting;
    }
  },
  watch: {
    drawer: function drawer(value) {
      if (!value) this.$emit("close");
    }
  },
  mounted: function mounted() {
    var _this2 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this2.drawer = true;
            _context.next = 3;
            return _this2.fetchCountries();
          case 3:
            _context.next = 5;
            return _this2.fetchWarehouses();
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    close: function close() {
      this.drawer = false;
    },
    fetchCountries: function fetchCountries() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var clientAppData, response;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this3.isLoadingCountries = true;
              clientAppData = {
                client_id: _this3.$whitelabel.clientId,
                client_secret: _this3.$whitelabel.clientSecret
              };
              _context2.next = 4;
              return request("/v1/countries?implantedMarket=true", "post", clientAppData, false, "api").catch(function (e) {
                var errorData = getErrorData(e, _this3.managedExceptions);
                handleErrorData(_this3, errorData);
                _this3.isLoadingCountries = false;
              });
            case 4:
              response = _context2.sent;
              if (response) {
                _this3.countries = _toConsumableArray(response.data.countries);
              }
              _this3.isLoadingCountries = false;
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    fetchWarehouses: function fetchWarehouses() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var response;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this4.isLoadingWarehouses = true;
              _context3.next = 3;
              return request("/v1/warehouses", "post", {
                paging: null
              }, true, "api").catch(function (e) {
                var errorData = getErrorData(e, _this4.managedExceptions, "Unable to get warehouses.");
                handleErrorData(_this4, errorData);
                _this4.isLoadingWarehouses = false;
              });
            case 3:
              response = _context3.sent;
              if (response) {
                _this4.warehouses = _toConsumableArray(response.data.warehouses);
              }
              _this4.isLoadingWarehouses = false;
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    buildExportQuery: function buildExportQuery() {
      var params = {
        reservationType: this.form.reservationType,
        warehouseIds: this.form.warehouseIds && this.form.warehouseIds.length ? this.form.warehouseIds.join(",") : null
      };
      var query = Object.entries(params).filter(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          value = _ref2[1];
        return value !== null && value !== undefined && value !== "";
      }).map(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
          key = _ref4[0],
          value = _ref4[1];
        return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(value));
      }).join("&");
      return query.length ? "?".concat(query) : "";
    },
    exportStocks: function exportStocks() {
      if (!this.canExport) return;
      var _this = this;
      _this.isExporting = true;
      var query = this.buildExportQuery();
      request("/v1/stocks/export/".concat(query), "get", null, true, "api", "blob").then(function (response) {
        _this.isExporting = false;
        fileDownload(response.data, "PLATFORM_STOCKS_LIST.xlsx", "application/xlsx");
        _this.close();
      }).catch(function (e) {
        _this.isExporting = false;
        var errorData = getErrorData(e, _this.managedExceptions);
        handleErrorData(_this, errorData);
      });
    },
    filterVAutocomplete: filterVAutocomplete
  }
};